import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import CategoriesList from '../categoriesList';

const BasicInfo = ({ name, website, description, categories }) => {
  return (
    <div>
      <div className="p-3 business-basic-info">
        <div className="business-name">{name}</div>
        <Link
          to={`//${website}`}
          target="_blank"
          className="text-primary business-website-link"
        >
          <FontAwesomeIcon icon="link" className="text-secondary" /> {website}
        </Link>
      </div>
      <hr className="m-0" />
      <div className="p-3">{description}</div>
      <hr className="m-0" />
      <div>
        <CategoriesList categories={categories} />
      </div>
    </div>
  );
};

export default BasicInfo;



// WEBPACK FOOTER //
// ./src/components/businessDetail/basicInfo/basicInfo.js